import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { formIdList } from "../etc/data";
import { dateToDateString } from "../../etc/etcfunctions";
import CustomInput from "../../etc/custominput";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import ImageUploadModalForCoaching from "../etc/imageuploadmodal";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button as Button2 } from "@mui/joy";

const FirstCoachTable: React.FC<any> = (props) => {


    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);

    const [filterModel, setFilterModel] = useState<any>({
        items: [
            { id: 2, field: "name", operator: "contains", value: "" }
        ]
    })
    const [loading, setLoading] = useState<boolean>(false);
    const [name, setName] = useState<string>("");
    const [rows, setRows] = useState<any[]>([]);
    const [update, setUpdate] = useState<number>(0);
    const [columns, setColumns] = useState<any[]>([
        { field: "seat", headerName: "좌석번호", width: 100 },
        { field: "name", headerName: "이름", width: 100 },
        { field: "firstCome", headerName: "첫 등원일", width: 100 },
        {
            field: "studentProfile", headerName: "학생 프로필", width: 150, renderCell: (params: any) => {

                const value = params.value;

                if (value === "미완료") {
                    return (
                        <div>
                            {value}
                        </div>
                    )
                }


                return (
                    <div>
                        <a href={value} target="_blank" rel="noopener noreferrer">
                            {params.row.studentProfileCreatedAt}
                        </a>
                    </div>
                )
            }
        },
        {
            field: "selectCoach", headerName: "코치 선택", width: 220, renderCell: (params: any) => {

                const value = params.value;

                const letsCancel = async () => {
                    const selectCoachId = params.row.selectCoachId;

                    console.log("Cancel select coach with ID: ", selectCoachId);

                    try {

                        setLoading(true);

                        const result: any = await postFetch("/dashboard/mycoach/cancelselectcoach", {
                            id: selectCoachId
                        });

                        console.log(result);

                        setLoading(false);

                        if (result.message === "success") {
                            setUpdate(Math.random());
                        }

                    } catch (e) {
                        console.error("Error in letsCancel: ", e);
                    }
                }


                if (value === "미선택") {
                    return (
                        <div>
                            {value}
                        </div>
                    )
                } else {


                    return (
                        <div>
                            {value}
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                    marginLeft: "32px"
                                }}
                                onClick={letsCancel}
                            >
                                취소시키기
                            </Button>
                        </div>
                    )

                }

            }
        },
        { field: "selectCoachResult", headerName: "코치 선택 응답", width: 100 },
        { field: "firstCoachingDate", headerName: "첫 코칭 날짜", width: 100 },
        {
            field: "deepResearch", headerName: "사전 심층 조사지", width: 150, renderCell: (params: any) => {
                const value = params.value;

                if (value === "미완료") {
                    return (
                        <div>
                            {value}
                        </div>
                    )
                }


                return (
                    <div>
                        <a href={value} target="_blank" rel="noopener noreferrer">
                            {params.row.deepResearchCreatedAt}
                        </a>
                    </div>
                )
            }
        },
        {
            field: "weekSchedule", headerName: "주간 일정표", width: 150, renderCell: (params: any) => {
                const value = params.value;

                if (value === "미완료") {
                    return (
                        <div>
                            {value}
                        </div>
                    )
                }

                if (value) {
                    return (
                        <div>
                            <a href={value} target="_blank" rel="noopener noreferrer">
                                {params.row.weekScheduleCreatedAt}
                            </a>
                        </div>
                    )
                }


            }
        },
        {
            field : "lastCoachingReport", headerName : "마지막 리포트", width: 150
        }
    ]);

    const notify = () => toast.success("전송 성공!", {
            position: "bottom-right",
            autoClose: 2500,
            hideProgressBar: true,
            theme: "colored"
    });


    const handleModalClose = () => {
        setModalOpen(false);
    }

    const getData = async () => {

        try {

            const result: any = await getFetch("/dashboard/mycoach/getformdata");

            const data = result.data;

            const users = data.users || [];
            const filloutData = data.filloutData || [];
            const applyTeacherSelect = data.applyTeacherSelect || [];
            const coachingReportImg = data.coachingReportImg || [];


            const newRows: any = [];

            users.forEach((user: any) => {

                const oneRow: any = {};

                oneRow.id = user.id;
                oneRow.seat = user.seat;
                oneRow.name = user.name;

                if (user.firstCome) {
                    const firstComeDate = new Date(user.firstCome);
                    oneRow.firstCome = `${firstComeDate.getFullYear()}-${(firstComeDate.getMonth() + 1).toString().padStart(2, '0')}-${firstComeDate.getDate().toString().padStart(2, '0')}`;
                }

                oneRow.studentProfile = "미완료";

                filloutData.forEach((fillout: any) => {
                    if (fillout.userId === user.id && fillout.formId === formIdList.studentProfile) {

                        var studentProfileText = "";

                        const createdAt = new Date(fillout.createdAt);
                        const createdAtText = dateToDateString(createdAt, true);

                        oneRow.studentProfileCreatedAt = createdAtText;
                        oneRow.studentProfile = fillout.editLink;

                    }

                    if (fillout.userId === user.id && fillout.formId === formIdList.deepResearch) {

                        var deepResearchText = "";

                        const createdAt = new Date(fillout.createdAt);
                        const createdAtText = dateToDateString(createdAt, true);

                        oneRow.deepResearchCreatedAt = createdAtText;
                        oneRow.deepResearch = fillout.editLink;

                    }

                    if (fillout.userId === user.id && fillout.formId === formIdList.weekSchedule) {

                        var weekScheduleText = "";

                        const createdAt = new Date(fillout.createdAt);
                        const createdAtText = dateToDateString(createdAt, true);

                        var link = "";

                        if (fillout && fillout.questions && fillout.questions.length > 0 && fillout.questions[0].value && fillout.questions[0].value.length > 0) {
                            link = fillout.questions[0].value[0].url;
                        }

                        oneRow.weekScheduleCreatedAt = createdAtText;
                        oneRow.weekSchedule = link;

                    }

                });

                oneRow.selectCoach = "미선택";

                applyTeacherSelect.forEach((select: any) => {

                    if (select.studentId === user.id) {

                        var selectCoachText = "";

                        const createdAtDate = new Date(select.createdAt);
                        const createdAtText = dateToDateString(createdAtDate, true);
                        const teacherName = select.teacherName;

                        oneRow.selectCoachId = select.id;
                        oneRow.selectCoach = `${teacherName} (${createdAtText})`;
                        oneRow.selectCoachResult = "";

                        if (select.succeedAt) {
                            const succeedAtDate = new Date(select.succeedAt);
                            const succeedAtText = dateToDateString(succeedAtDate, true);
                            oneRow.selectCoachResult = `승인됨 (${succeedAtText})`;
                        }

                        if (select.failedAt) {
                            const failedAtDate = new Date(select.failedAt);
                            const failedAtText = dateToDateString(failedAtDate, true);
                            oneRow.selectCoachResult = `거절됨 (${failedAtText}) (${select.failDescription})`;
                        }

                    }

                });

                coachingReportImg.forEach((report: any) => {

                    const studentId = report.studentId;

                    if( studentId === user.id) {

                        const createdAtDate = new Date(report.createdAt);
                        const createdAtText = dateToDateString(createdAtDate, true);

                        //오늘로부터 몇일 전인지 계산
                        const today = new Date();
                        const daysAgo = Math.floor((today.getTime() - createdAtDate.getTime()) / (1000 * 60 * 60 * 24));

                        const text = `${daysAgo}일 전 (${createdAtText})`;
                        oneRow.lastCoachingReport = text;

                    }

                });

                newRows.sort((a: any, b: any) => {
                    const AfterSeat = a.seat || 9999999999;
                    const BeforeSeat = b.seat || 9999999999;

                    return AfterSeat - BeforeSeat;
                })


                newRows.push(oneRow);

            })

            setRows([...newRows])



        } catch (e) {
            console.error("Error in getData: ", e);
        }

    }

    useEffect(() => {
        getData();
    }, [update]);

    const handleSearch = (name: string) => {

        setName(name);

        const newFilterModel: any = filterModel;
        newFilterModel.items.forEach((each: any) => {
            if (each.id === 2) {
                each.value = name;
            }
        })
        setFilterModel({ ...newFilterModel });

    }


    return (
        <div>
            <div style={{
                width: "1500px",
                marginBottom: "8px",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "16px",
            }}>
                <div>
                    <Button2
                    variant="soft"
                    disabled={!selectedUserId}
                    onClick={() => {
                        setModalOpen(true);
                    }}
                    >
                        수업기록지 전송하기
                    </Button2>
                </div>
                <div>
                    <CustomInput
                        value={name}
                        onChange={(e: any) => { handleSearch(e.target.value); }}
                        placeholder="이름으로 검색"
                        style={{
                            width: "300px",
                            marginBottom: "16px"
                        }}
                    />
                </div>
            </div>
            <div style={{
                height: "900px",
                width: "1500px",
                backgroundColor: "#fff",
            }}>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    density="compact"
                    filterModel={filterModel}
                    onFilterModelChange={(model: any) => {
                        setFilterModel(model);
                    }}
                    onRowClick={(params: any) => {
                        const userId = params.row.id;
                        console.log("Selected user ID: ", userId);
                        setSelectedUserId(userId);
                    }}
                />
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ImageUploadModalForCoaching
            open={modalOpen}
            handleClose={handleModalClose}
            update={getData}
            success={notify}
            userId={selectedUserId}
            />

        </div>
    )
}

export default FirstCoachTable;

